import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * `/onboarding/step-4` — document type default timers.
 * Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/onboarding/step-4",
	component: lazyRouteComponent(() => import("./step-4.page")),
})
